export enum EventSource {
  // Describes direct user action
  USER_INTERACTION = 'User Interaction',

  // Occurs as a result of indirect user action
  USER_EFFECT = 'User Effect',

  // An event triggered when the system is initializing
  SYSTEM_INIT = 'System Initialise',

  // Occurs when a server event is received
  SERVER_EVENT = 'Server Event',

  // Rendering
  VIEW_RENDER = 'View Render',

  // Page View
  PAGE_VIEW = 'Page View'
}

export enum InteractionType {
  CLICK = 'Click',
  SCROLL = 'Scroll',
  DRAG = 'Drag',
  DROP = 'Drop',
  HOVER = 'Hover',
  RIGHT_CLICK = 'Right Click',
  KEY_PRESS = 'Key Press',
  ZOOM_IN = 'Zoom In',
  ZOOM_OUT = 'Zoom Out',
  RESIZE = 'Resize',
  PAGE_VIEW = 'Page View',
  N_A = 'N/A'
}

export enum ComponentType {
  DIALOG_CONFIRM_BUTTON = 'Dialog Confirm Button',
  DIALOG_CANCEL_BUTTON = 'Dialog Cancel Button',
  DIALOG_BUTTON = 'Dialog Button',
  MUI_SELECT = 'MUI Select',
  CLOSE_BUTTON = 'Close Button',
  INTERNAL_LINK_BUTTON = 'Internal Link Button',
  N_A = 'N/A'
}

export type AdditionalDetails = Record<string, string | boolean | number>;

export type UserEventTracker = <Type = AdditionalDetails>(event: UserEvent, additionalDetail?: Type) => void;

export interface UserEvent {
  eventDescription: string;
  eventKey: string;
  eventSource: EventSource;
  interactionType?: InteractionType;
  componentType?: ComponentType;
  details?: AdditionalDetails;
}
